module.exports = __webpack_public_path__ + "img/IMG_20200626_232654.1dd62f88.jpg";